const config = {};

export const MAX_CHALLENGES = 6;
export const REVEAL_TIME_MS = 350;
export const GAME_START_DATE = "2025/11/25";

export default config;
